import type { ReactNode } from 'react'
import { SuspenseLoader } from 'v2/shared/components/suspense-loader'
import { useVoiceAccessGate } from '../hooks/use-voice-access-gate'
import { RequestAccessCard } from './request-access-card'

interface VoiceGatedProps {
  children: ReactNode
  title: ReactNode
  message: ReactNode
}

export const VoiceGated = ({ children, title, message }: VoiceGatedProps) => {
  const { isChecking, isGated } = useVoiceAccessGate()
  if (isChecking) return <SuspenseLoader />
  if (isGated) {
    return (
      <RequestAccessCard feature="voice" featureLabel="Voice" title={title} message={message} />
    )
  }
  return <>{children}</>
}
